import React from "react";

export default function SearchRow({
  searchValue,
  onSearch,
  onCreate,
  createLabel = "+ Create New",
  placeholder = "Search here",
  canCreate = true,
}) {
  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row">
      <div className="flex flex-1 items-center gap-2 rounded-lg border border-gray-300 bg-white px-3.5 py-2.5">
        <svg className="h-4 w-4 shrink-0 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8" strokeWidth="2" />
          <path d="m21 21-4.35-4.35" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <input
          value={searchValue}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={placeholder}
          className="flex-1 border-none bg-transparent text-sm text-gray-700 outline-none placeholder-gray-400 font-sans"
        />
      </div>

      <button className="w-full whitespace-nowrap rounded-lg border border-green-200 bg-[#D9FBD4] px-5 py-2.5 text-sm font-semibold text-green-600 transition hover:bg-green-100 sm:w-auto">
        Search
      </button>

      {canCreate && (
        <button
          onClick={onCreate}
          className="flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-lg bg-green-700 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-green-800 sm:w-auto"
        >
          {createLabel}
        </button>
      )}
    </div>
  );
}

